var map = {
	"./miejsce-parkingowe-wolne.svg": "1dca",
	"./miejsce-parkingowe-zajete.svg": "f70d",
	"./miejsce-parkingowe.svg": "5bb8",
	"./obszary-parkingowe.svg": "e81a",
	"./parkingi--green.svg": "47de",
	"./parkingi--red.svg": "802c",
	"./parkingi.svg": "af47",
	"./parkomaty.svg": "9e1e",
	"./roboty-drogowe.svg": "2cc3",
	"./stacje-meteo.svg": "ecb7",
	"./strefy-parkowania.svg": "3775",
	"./wypadki.svg": "edc0",
	"./zagrozenia.svg": "6a15",
	"./zamkniecia-drog.svg": "5704",
	"./zdarzenia.svg": "7633"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bc11";